/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mBtnFace.vue?vue&type=template&id=1819890a&scoped=true"
import script from "./mBtnFace.vue?vue&type=script&lang=js"
export * from "./mBtnFace.vue?vue&type=script&lang=js"
import style0 from "./mBtnFace.vue?vue&type=style&index=0&id=1819890a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1819890a",
  null
  
)

export default component.exports